<template>
  <div style="position: relative;">
    <el-form ref="UserListFilter" :model="UserList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="登录账号" prop="formFilter.loginName">
            <el-input class="filter-item" v-model="UserList.formFilter.loginName"
                      :clearable="true" placeholder="登录账号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="姓名" prop="formFilter.showName">
            <el-input class="filter-item" v-model="UserList.formFilter.showName"
                      :clearable="true" placeholder="姓名"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别" prop="formFilter.gender">
            <el-select class="filter-item" v-model="UserList.formFilter.gender" :clearable="true" filterable
                       placeholder="性别" :loading="UserList.gender.impl.loading"
                       @visible-change="UserList.gender.impl.onVisibleChange"
                       @change="onGenderValueChange">
              <el-option v-for="item in UserList.gender.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属部门" prop="formFilter.deptId">
            <el-cascader class="filter-item" v-model="UserList.formFilter.deptId" :clearable="true" filterable
                         placeholder="所属部门" :loading="UserList.deptId.impl.loading" :props="{value: 'deptId', label: 'deptName', checkStrictly: true}"
                         @visible-change="UserList.deptId.impl.onVisibleChange" :options="UserList.deptId.impl.dropdownList"
                         @change="onDeptIdValueChange">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职位状态" prop="formFilter.jobStatus">
            <el-select class="filter-item" v-model="UserList.formFilter.jobStatus" :clearable="true" filterable
                       placeholder="职位状态" :loading="UserList.jobStatus.impl.loading"
                       @visible-change="UserList.jobStatus.impl.onVisibleChange"
                       @change="onJobStatusValueChange">
              <el-option v-for="item in UserList.jobStatus.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工龄" prop="formFilter.workYears">
            <input-number-range class="filter-item"
                                v-model="UserList.formFilter.workYears" :clearable="true"
                                startPlaceholder="最小值" endPlaceholder="最大值"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="薪级" prop="formFilter.jobLevelId">
            <el-cascader class="filter-item" v-model="UserList.formFilter.jobLevelId" :clearable="true" filterable
                       placeholder="薪级" :loading="UserList.jobLevelId.impl.loading" :props="{value: 'id', label: 'name'}"
                       @visible-change="UserList.jobLevelId.impl.onVisibleChange" :options="UserList.jobLevelId.impl.dropdownList"
                       @change="onJobLevelIdValueChange">
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="职称" prop="formFilter.jobTitleId">
            <el-cascader class="filter-item" v-model="UserList.formFilter.jobTitleId" :clearable="true" filterable
                       placeholder="职称" :loading="UserList.jobTitleId.impl.loading" :props="{value: 'id', label: 'name'}"
                       @visible-change="UserList.jobTitleId.impl.onVisibleChange" :options="UserList.jobTitleId.impl.dropdownList"
                       @change="onJobTitleIdValueChange">
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <filter-box :item-width="350">
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetUserList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshUserList(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="UserList" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col class="table-box gutter-bottom" :span="24">
          <el-table ref="sysUser" :data="UserList.SysUser.impl.dataList" :size="defaultFormItemSize" @sort-change="UserList.SysUser.impl.onSortChange"
            header-cell-class-name="table-header-gray" height="420"
            highlight-current-row @current-change="UserList.SysUser.impl.currentRowChange" @row-click="handleRowClick"
          >
            <el-table-column type="selection" width="55px"></el-table-column>
            <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="UserList.SysUser.impl.getTableIndex" />
            <el-table-column label="登录账号" prop="loginName">
            </el-table-column>
            <el-table-column label="姓名" prop="showName">
            </el-table-column>
            <el-table-column label="性别" prop="genderDictMap.name">
            </el-table-column>
            <el-table-column label="用户状态" prop="userStatusDictMap.name">
            </el-table-column>
            <el-table-column label="职位状态" prop="jobStatusDictMap.name">
            </el-table-column>
            <el-table-column label="薪级" prop="jobLevelIdDictMap.name">
            </el-table-column>
            <el-table-column label="职称" prop="jobTitleIdDictMap.name">
            </el-table-column>
            <el-table-column label="工龄" prop="workYears">
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onAddClick()">
              选择
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {
  SysUserController,
  DictionaryController,
  SysDeptController,
  PaJobTitleController,
  PaJobLevelController
} from '@/api';

export default {
  name: 'SelectUser',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      },
      UserList: {
        formFilter: {
          loginName: undefined,
          deptId: undefined,
          showName: undefined,
          jobStatus: '1',
          workYears: [],
          jobLevelId: undefined,
          jobTitleId: undefined,
          gender: undefined
        },
        formFilterCopy: {
          loginName: undefined,
          deptId: undefined,
          showName: undefined,
          jobStatus: undefined,
          workYears: [],
          jobLevelId: undefined,
          jobTitleId: undefined,
          gender: undefined
        },
        deptId: {
          impl: new DropdownWidget(this.loadDeptIdDropdownList, true, 'deptId')
        },
        jobStatus: {
          impl: new DropdownWidget(this.loadJobStatusDropdownList)
        },
        jobLevelId: {
          impl: new DropdownWidget(this.loadJobLevelIdDropdownList, true, 'id', 'pid')
        },
        jobTitleId: {
          impl: new DropdownWidget(this.loadJobTitleIdDropdownList, true, 'id', 'pid')
        },
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        SysUser: {
          impl: new TableWidget(this.loadSysUserWidgetData, this.loadSysUserVerify, false, true, 'showName', 1)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      this.$refs.sysUser.toggleRowSelection(row);
    },
    onAddClick () {
      this.onCancel(true, this.$refs.sysUser.selection)
    },
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    onResetUserList () {
      this.$refs.UserListFilter.resetFields();
      this.refreshUserList(true);
    },
    /**
     * 用户管理数据获取函数，返回Promise
     */
    loadSysUserWidgetData (params) {
      if (params == null) params = {};
      let jobLevelId = this.UserList.formFilterCopy.jobLevelId; jobLevelId = Array.isArray(jobLevelId) ? jobLevelId[jobLevelId.length - 1] : undefined;
      let jobTitleId = this.UserList.formFilterCopy.jobTitleId; jobTitleId = Array.isArray(jobTitleId) ? jobTitleId[jobTitleId.length - 1] : undefined;
      params = {
        ...params,
        sysUserDtoFilter: {
          loginName: this.UserList.formFilterCopy.loginName,
          deptTid: this.UserList.formFilterCopy.deptId,
          showName: this.UserList.formFilterCopy.showName,
          userStatus: this.SysUserStatus.NORMAL,
          gender: this.UserList.formFilterCopy.gender,
          jobStatus: this.UserList.formFilterCopy.jobStatus,
          workYearsStart: Array.isArray(this.UserList.formFilterCopy.workYears) ? this.UserList.formFilterCopy.workYears[0] : undefined,
          workYearsEnd: Array.isArray(this.UserList.formFilterCopy.workYears) ? this.UserList.formFilterCopy.workYears[1] : undefined,
          jobLevelId: jobLevelId,
          jobTitleId: jobTitleId
        }
      }
      return new Promise((resolve, reject) => {
        SysUserController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.UserList.SysUser.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.UserList.SysUser.impl.currentRow.userId, 'userId');
              this.$refs.sysUser.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 用户管理数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysUserVerify () {
      this.UserList.formFilterCopy.loginName = this.UserList.formFilter.loginName;
      this.UserList.formFilterCopy.deptId = this.UserList.formFilter.deptId;
      this.UserList.formFilterCopy.showName = this.UserList.formFilter.showName;
      this.UserList.formFilterCopy.gender = this.UserList.formFilter.gender;
      this.UserList.formFilterCopy.jobStatus = this.UserList.formFilter.jobStatus;
      this.UserList.formFilterCopy.workYears = this.UserList.formFilter.workYears;
      this.UserList.formFilterCopy.jobLevelId = this.UserList.formFilter.jobLevelId;
      this.UserList.formFilterCopy.jobTitleId = this.UserList.formFilter.jobTitleId;
      return true;
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadDeptIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        SysDeptController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属部门选中值改变
     */
    onDeptIdValueChange (value) {
    },
    /**
     * 职位状态下拉数据获取函数
     */
    loadJobStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_job_status'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 职位状态选中值改变
     */
    onJobStatusValueChange (value) {
    },
    /**
     * 薪级下拉数据获取函数
     */
    loadJobLevelIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        PaJobLevelController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 薪级选中值改变
     */
    onJobLevelIdValueChange (value) {
    },
    /**
     * 职称下拉数据获取函数
     */
    loadJobTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        PaJobTitleController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 职称选中值改变
     */
    onJobTitleIdValueChange (value) {
    },
    /**
     * 性别下拉数据获取函数
     */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGender(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 性别选中值改变
     */
    onGenderValueChange (value) {
    },
    /**
     * 更新员工列表
     */
    refreshUserList (reloadData = false) {
      if (reloadData) {
        this.UserList.SysUser.impl.refreshTable(true, 1);
      } else {
        this.UserList.SysUser.impl.refreshTable();
      }
      if (!this.UserList.isInit) {
        // 初始化下拉数据
        this.UserList.jobStatus.impl.onVisibleChange(true).catch(e => {});
      }
      this.UserList.isInit = true;
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshUserList();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.SysUser = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
